import React,{useState, useEffect} from 'react'
import Form from '../components/Form'
import PokemonCards from '../components/PokemonCard'
import {
    useRouteMatch,
    Switch,
    Route
} from 'react-router-dom'

import Detail from './Detail'

import { useSelector, useDispatch} from 'react-redux'
import {getPokemons} from '../store/actions/pokemonAction'

export default function Home() {
    const [number,setNumber] = useState(6)
    const pokemons = useSelector((state)=> state.pokemonReducer.pokemons)
    const dispatch = useDispatch()
    
    const {path} = useRouteMatch()

    useEffect(()=>{
        dispatch(getPokemons(number))
    },[number,dispatch])

    function onFormSubmit(data) {
        setNumber(data)
    }

    return (
        <>
            <Switch>
                <Route path={`${path}/:pokemonId`}>
                    <Detail />
                </Route>
                <Route path={`${path}`}>
                    <h2 className="ml-3" data-testid="pokemon-list-title" style={{textAlign:"center"}}>Pokemon Lists</h2>
                    <Form onNumberSubmit={onFormSubmit} />
                    <PokemonCards pokemons={pokemons} />
                </Route>
            </Switch>
        </>
    )
}